export default {
  pageOptions: (state, options) => {
    state.options = options;
  },
};
